import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../../variables/api/axiosInstance";
import {
    Alert,
    Button,
    Card,
    Col,
    Descriptions,
    Divider,
    Image,
    InputNumber,
    Modal,
    Row,
    Space,
    Table,
    Tabs,
    Tag,
    Tooltip,
    Typography
} from "antd";
import SinglePageLayout from "../../../../../layout/SinglePageLayout";
import OrderTimeline from "../../../components/modals/OrderTimeline";
import TextArea from "antd/es/input/TextArea";
import { toast } from "react-toastify";
import {
    formatCurrency,
    formatCurrencyWithCurrencyCode,
    formatFrenchDate,
    getActionVerb,
    getAntdIcon,
    getCodeHabilitation,
    isConnectedUserFromPOOL
} from "../../../../../variables/functions";
import AffecterLotAttestation from "../../../components/modals/AffecterLotAttestation";
import { loadTaxes, updateBonCommande, validateWithComment } from "../../../../../hooks/useHooks";
import ReceiptCard from "../../../../caisse/components/ReceiptCard";
import TrustworthinessStats from "../../../components/TrustworthinessStats";
import { API_URL, TOKEN } from "../../../../../variables/constants";
import { rightsService } from "../../../../../services/rightsService";
import { ExclamationCircleFilled, InfoCircleOutlined } from "@ant-design/icons";
import DefaultCommentSuggestions from "../../../components/DefaultCommentSuggestions";
import ValidationAttestattionConfirm from "../../../components/modals/ValidationAttestationConfirm";
import InvoiceCard from "../../../../caisse/components/InvoiceCard";


const { Title, Text } = Typography;

const DetailsCompagnie = () => {
    const { commandeId } = useParams();
    const [bonCommande, setBonCommande] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [editData, setEditData] = useState(null);
    const [timelineOpen, setTimelineOpen] = useState(false);
    const [commentaire, setCommentaire] = useState('');
    const [reload, setReload] = useState(false)
    const [openAffectationModal, setOpenAffectationModal] = useState(false)
    const [livraisonData, setLivraisonData] = useState({})
    const [livrerLoading, setLivrerLoading] = useState(false)
    const [loadingOrders, setLoadingOrders] = useState(false)
    const [allOrderForCompany, setAllOrderForCompany] = useState(null)
    const [logoImagePreviewUrl, setLogoImagePreviewUrl] = useState(null)
    const [taxe, setTaxe] = useState(null)
    const [updateCommentaire, setUpdateCommentaire] = useState('')
    const [validationModalOpen, setValidationModalOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [receiptModalOpen, setReceiptModalOpen] = useState(false)
    let com = ""


    const navigate = useNavigate()
    useEffect(() => {
        loadTaxes(setTaxe);
    }, []);

    useEffect(() => {
        if (updateCommentaire) {
            com = updateCommentaire
        }
    }, [updateCommentaire]);


    useEffect(() => {
        if (commandeId) {
            axiosInstance
                .get(`/api/bon-commande/${commandeId}`)
                .then((res) => setBonCommande(res.data))
                .catch(() => console.log("Une erreur s'est produite"));
        }
    }, [commandeId, reload]);
    useEffect(() => {
        if (!bonCommande?.compagnie?.code) return;
        axiosInstance
            .get(`/api/bon-commande/compagnie/${bonCommande.compagnie.code}`)
            .then((res) => {
                console.log('Hey');
                setAllOrderForCompany(res.data);
            })
            .catch((e) => {
                console.log(e);
                toast.error("Une erreur s'est produite");
            });
        if (bonCommande?.compagnie?.logo) {
            fetch(`${API_URL}/api/organisme/logo/${bonCommande?.compagnie?.logo.split("/")[1]}`, {
                headers: {
                    Authorization: `Bearer ${TOKEN}`,
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS",
                    "Access-Control-Allow-Headers": "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
                },
            })
                .then(async (response) => {
                    // convert byte to file
                    const imageBytes = await response.arrayBuffer();
                    const blob = new Blob([imageBytes], { type: "image/png" });
                    const imageUrl = URL.createObjectURL(blob);
                    setLogoImagePreviewUrl(imageUrl);
                    setTimeout(() => {
                        console.log("Preview: ", { logoImagePreviewUrl });
                    }, 1000);
                })
                .catch((error) => {
                    console.log(error);
                });
        }


    }, [bonCommande]);


    console.log(bonCommande?.compagnie?.code)
    console.log(allOrderForCompany)

    const handleEditClick = (unit) => {
        setEditData({ ...unit });
        setIsEditing(true);
    };
    const handleLivraisonClick = (unit) => {
        setLivraisonData({ ...unit });
        setOpenAffectationModal(true)
    };
    console.log(bonCommande)

    const handleSave = () => {
        const updatedProducts = bonCommande.produitAttestationCommandes.map((unit) => unit.codeId === editData.codeId ? {
            ...unit, quantite: editData.quantite
        } : unit);
        setBonCommande({ ...bonCommande, produitAttestationCommandes: updatedProducts });
        setIsEditing(false);

        const updateQuantityDTO = {
            commandeCodeId: commandeId,
            produitCommandeCodeId: editData?.codeId,
            newQuantite: editData?.quantite,
            commentaire: commentaire
        }
        axiosInstance
            .put('api/bon-commande/quantity', updateQuantityDTO)
            .then((res) => {
                console.log(res)
                setReload((prevState) => !prevState)
                toast("Mise à jour effectuée avec succes!")
            })
            .catch((e) => {
                console.log(e)
                toast.error("Une erreur s'est produite ")
            })
    };

    const handleCancel = () => {
        setIsEditing(false);
    };
    console.log(livraisonData)
    if (!bonCommande) return <p style={{ textAlign: "center", color: "#999" }}>Chargement...</p>;

    const productColumns = [{
        title: "Code", dataIndex: "codeId", key: "codeId",
    }, {
        title: "Catégorie", key: "categorie", render: (_, record) => {
            const categorie = record.produitAttestation?.categorie;
            return categorie ? `${categorie.nom} (${categorie.codeCategorie})` : "N/A";
        },
    }, {
        title: "Type",
        key: "typeAttestation",
        render: (_, record) => record.produitAttestation?.typeAttestation || "N/A",
    }, {
        title: "Quantité", dataIndex: "quantite", key: "quantite",
    }, {
        title: "Prix Unitaire", key: "montant", render: (_, record) => {
            const montant = record.produitAttestation?.montant;
            return montant ? ` ${formatCurrency(montant)}` : "N/A";
        },
    }, {
        title: "Total", key: "total", render: (_, record) => {
            const montant = record.produitAttestation?.montant;
            const total = montant ? montant * record.quantite : 0;
            return ` ${formatCurrency(total)}`;
        },
    },];

    if (!isConnectedUserFromPOOL() && bonCommande?.statutCommande === 'INITIE' || bonCommande?.statutCommande === 'VALIDE') {
        productColumns.push({
            title: "Actions",
            key: "actions",
            render: (_, record) => (<Button onClick={() => handleEditClick(record)} type="primary">
                Modifier
            </Button>),
        });
    }


    if (isConnectedUserFromPOOL() && bonCommande?.statutCommande === 'APPROUVE') {
        productColumns.push({
            title: "Actions",
            key: "actions",
            render: (_, record) => !record?.delivered && record?.produitAttestation?.moyenReglement === 'RETROCESSION' ? (
                <Button onClick={() => handleLivraisonClick(record)} type="primary" style={{
                    width: '100%'
                }}>
                    Livrer
                </Button>) :
                <Tooltip title={'La livraison de cette attestation doit être effectuée apres le règlement'}>
                    <Button type="primary" style={{
                        backgroundColor: 'orange',
                        width: '100%'
                    }}>
                        <InfoCircleOutlined />
                    </Button>
                </Tooltip>
            ,
        });
    }

    const validation = (lotA, updateCommentaire) => {
        setLoadingOrders(true)
        setLoading(true)
        const com = updateCommentaire;
        console.log(updateCommentaire);
        const validationBonCommandeDTO = {
            bonCommandeCodeId: lotA, commentaire: com, produitAttestationCommande: livraisonData
        };
        validateWithComment(validationBonCommandeDTO)
            .then((r) => {
                setValidationModalOpen(false)
                toast("Commande validée avec succès !");
                setReload((prevState) => !prevState);
                setLoadingOrders(false)
                setLoading(false)

            })
            .catch((error) => {
                setLoadingOrders(false)
                toast("Erreur lors de la validation !");
                setLoading(false)

            });
        setLoadingOrders(false)
        //   setReload((prevState) => !prevState);
        setLoading(false)

    };

    const onSubmit = (plage, selectedTypeAttestation, selectedCategorie, nombre,) => {
        console.log()
        setLivrerLoading(true);
        if (plage?.length === 0) {
            toast.error("Aucune plage n'a été saisie",);
        }
        if (nombre === plage?.length) {
            validation(bonCommande?.codeId, com);
            let lot = {
                compagnie: bonCommande?.compagnie,
                lot: plage,
                updatedLot: plage,
                categorie: livraisonData?.produitAttestation?.categorie,
                typeAttestation: selectedTypeAttestation,
            };
            axiosInstance
                .post(`/api/lot-attestation`, JSON.stringify(lot))
                .then((res) => {
                    if (res.status === 226) {
                        toast("Ce numéro d'attestation existe déjà!");
                    } else {
                        setOpenAffectationModal(false);
                        setReload(true);
                        toast("Lot d'attestation ajoutée avec succès");
                    }
                    setLivrerLoading(false);
                })
                .catch((err) => {
                    if (err.response.status === 226) {
                        toast("Ce numéro d'attestation existe déjà!");
                    } else {
                        toast("Erreur lors de l'ajout du lot d'attestation");
                    }
                    setLivrerLoading(false);
                });
        } else {
            setLivrerLoading(false);

            toast("Veuillez vérifier les valeurs que vous avez saisi!");
        }
    };


    const poolActions = bonCommande?.actionsSurCommande.filter((action) => action?.action === 'TRAITER' || action?.action === 'APPROUVER' || action?.action === 'LIVRER')
    console.log(bonCommande.produitAttestationCommandes)
    const returnActionDataSource = () => {
        if (isConnectedUserFromPOOL()) {
            return poolActions
        } else {
            return bonCommande?.actionsSurCommande
        }
    }

    const actionsColumns = [{
        title: "Code", dataIndex: "codeId", key: "codeId",
    }, {
        title: "Action", dataIndex: "action", key: "action",
    }, {
        title: "Acteur",
        key: "acteur",
        render: (_, record) => record.acteur?.personne ? `${record.acteur.personne.nom} ${record.acteur.personne.prenom}` : "N/A",
    }, {
        title: "Commentaire", dataIndex: "commentaire", key: "commentaire",
    }, {
        title: "Date d'action",
        dataIndex: "dateAction",
        key: "dateAction",
        render: (date) => (date ? new Date(date).toLocaleString() : "N/A"),
    },];

    const getTagColor = (statutCommande) => {
        switch (statutCommande) {
            case "INITIE":
                return "blue";
            case "VALIDE":
                return "green";
            case "AUTORISE":
                return "gold";
            case "CONFIRME":
                return "purple";
            case "DELIVRE":
                return "cyan";
            case "RECEPTIONNE":
                return "volcano";
            default:
                return "default";
        }
    };
    const getSuccessor = (statutCommande) => {
        switch (statutCommande) {
            case "INITIE":
                return "VALIDE";
            case "VALIDE":
                return "AUTORISE";
            case "AUTORISE":
                return "CONFIRME";
            case "TRAITEMENT":
                return "APPROUVE";
            case "APPROUVE":
                return "REGLE";
            // case "APPROUVE":
            //     return "DELIVRE";
            case "CONFIRME":
                return "DELIVRE";
            case "DELIVRE":
                return "RECEPTIONNE";
            case "RECEPTIONNE":
                return "volcano";
            default:
                return "default";
        }
    };
    const getTaxe = () => {
        return (bonCommande?.reglement?.montant * taxe?.valeur) / 100;
    }


    const onSubmitCommandeAttestation = () => {
        setReload((prevState) => !prevState)
    };

    console.log(updateCommentaire)

    const reject = (record, updateCommentaire) => {
        const updatedBonCommande = { ...record };
        updatedBonCommande.statutCommande = "REJETE";
        updatedBonCommande.motifRejet = updateCommentaire;
        updateBonCommande(updatedBonCommande).then((r) => {
            setReload((prevState) => !prevState);
            toast.success("Commande rejetée avec succes");
        });
    };


    const showValidationAttestationConfirm = (lotA, statutCommande) => {
        Modal.confirm({
            title: `Êtes-vous sûr de vouloir ${getActionVerb(statutCommande)} la commande ?`,
            icon: <ExclamationCircleFilled style={{ color: "#1890ff", fontSize: "24px" }} />,
            width: 700,
            content: (<div style={{ padding: "1rem" }}>
                <p style={{ color: "#faad14", marginBottom: "1rem", fontSize: "16px", fontWeight: 500 }}>
                    Toutes vos actions sont historisées.
                </p>
                <div style={{ marginBottom: "1rem" }}>
                    <label
                        htmlFor="commentaire"
                        style={{ display: "block", marginBottom: "0.5rem", fontWeight: 600, fontSize: "15px" }}
                    >
                        Faites un commentaire :
                    </label>
                    <TextArea
                        rows={3}
                        value={updateCommentaire}
                        onChange={(e) => {
                            com = e.target.value
                            setUpdateCommentaire(e.target.value)
                        }}
                        placeholder="Votre commentaire ici ..."
                        style={{
                            borderRadius: "8px",
                            padding: "10px",
                            border: "1px solid #d9d9d9",
                            width: "100%",
                            fontSize: "14px",
                            boxSizing: "border-box"
                        }}
                    />
                    <div style={{ marginTop: "12px" }}>
                        <DefaultCommentSuggestions
                            statutCommande={getSuccessor(statutCommande)}
                            onSelect={setUpdateCommentaire}
                        />
                    </div>
                </div>
            </div>),
            okText: "Oui",
            okType: "primary",
            cancelText: "Annuler",
            onOk: () => validation(lotA, updateCommentaire),
        });
    };

    const showRejectBonCommandeConfirm = (record) => {
        Modal.confirm({
            title: `Etes-vous sûr de vouloir rejeter la commande?`,
            icon: <ExclamationCircleFilled color={"blue"} />,
            content: (<>
                <p style={{ color: "red", marginBottom: "1rem" }}>
                    Toutes vos actions sont historisées
                </p>
                <div style={{ marginBottom: "1rem" }}>
                    <label htmlFor="commentaire">Motif de rejet :</label>
                    <textarea
                        id="commentaire"
                        style={{
                            width: "100%",
                            marginTop: "0.5rem",
                            padding: "0.5rem",
                            borderRadius: "4px",
                            border: "1px solid #d9d9d9",
                        }}
                        placeholder="Votre commentaire ici..."
                        onChange={(e) => {
                            com = e.target.value;
                            setUpdateCommentaire(e.target.value);
                        }}
                    />
                </div>
            </>),
            okText: "Oui",
            okType: "primary",
            cancelText: "Annuler",
            onOk: () => reject(record, com),
        });
    };

    const getMessage = () => {
        if (bonCommande?.statutCommande === 'AUTORISE') {
            return `Cette commande est en attente d'approbation par le POOL`
        } else if (bonCommande?.statutCommande === 'REGLE') {
            return `Cette commande est en attente de livraison`
        } else if (bonCommande?.statutCommande === 'TRAITEMENT') {
            return `Cette commande est en cours de traitement`
        }
    }

    return (<SinglePageLayout style={{ maxWidth: "960px", margin: "0 auto", padding: "20px" }}>
        <Card
            bordered={false}
            title={<Title level={5} style={{ margin: 0 }}>
                {`Commande numero  ${bonCommande.codeId}`}
            </Title>}
            extra={<div style={{
                display: 'flex', flexDirection: 'row', gap: '10px'
            }}>
                <Title level={5} style={{ margin: 0 }}> Statut de la commande </Title>
                <Tag
                    color={getTagColor(bonCommande?.statutCommande)}
                    style={{ float: "right" }}
                >
                    {bonCommande.statutCommande}
                </Tag>
            </div>}
        >
            <Row justify="space-between" align="top">
                {/* Left side: Icon + Order Info */}
                <Col>
                    <Space align="start" size={16}>
                        <div>
                            <Descriptions
                                column={2}
                                size="small"
                                colon={true}
                                labelStyle={{ color: "#595959" }}
                                contentStyle={{ color: "#1a347d", fontWeight: '500', fontSize: '15px' }}
                                layout={"vertical"}
                                style={{ width: '67%', marginTop: 8 }}
                            >
                                <Descriptions.Item label="Compagnie">
                                    <Text strong style={{ color: "#1a347d" }}>
                                        {bonCommande.compagnie?.raisonSociale}
                                    </Text>
                                </Descriptions.Item>
                                <Descriptions.Item label="Date d'émission">
                                    {formatFrenchDate(bonCommande.dateEmission)}
                                </Descriptions.Item>
                            </Descriptions>
                            <Descriptions
                                column={3}
                                size="middle"
                                colon={true}
                                labelStyle={{ color: "#595959" }}
                                contentStyle={{ color: "#1a347d", fontWeight: '500', fontSize: '15px' }}
                                style={{ marginTop: 25 }}
                                layout={"vertical"}
                            >
                                <Descriptions.Item label="Montant Hors Taxe">
                                    {formatCurrencyWithCurrencyCode(bonCommande.reglement?.montant) || 0}
                                </Descriptions.Item>
                                <Descriptions.Item label={`Taxe (${taxe?.valeur}%)`}>
                                    {formatCurrencyWithCurrencyCode(getTaxe()) || 0}
                                </Descriptions.Item>
                                <Descriptions.Item label="Montant TTC">
                                    {formatCurrencyWithCurrencyCode((bonCommande.reglement?.montant || 0) + (getTaxe() || 0))}
                                </Descriptions.Item>
                            </Descriptions>
                        </div>
                    </Space>
                </Col>
            </Row>
            {!isConnectedUserFromPOOL() ? (
                <div
                    style={{
                        padding: "16px",
                        background: "#f9f9f9",
                        display: "flex",
                        justifyContent: "center",
                        gap: "16px",
                        marginTop: '30px'
                    }}
                >
                    {rightsService(getCodeHabilitation(bonCommande?.statutCommande)) && bonCommande?.statutCommande !== 'APPROUVE' ? (<>
                        <Button
                            type="primary"
                            style={{ backgroundColor: "#28a745", borderColor: "#28a745" }}
                            // icon={getAntdIcon(record.statutCommande)}

                            onClick={() => setValidationModalOpen(true)}
                        >
                            {`${getActionVerb(bonCommande.statutCommande)?.charAt(0).toUpperCase() + getActionVerb(bonCommande.statutCommande)?.slice(1).toLowerCase()}  `}
                        </Button>
                        {rightsService("HCO075") && (<Button

                            style={{
                                backgroundColor: "#dc3545", borderColor: "#dc3545", color: "#fff",
                            }}
                            icon={<i className="bx bx-message-alt-x"></i>}
                            onClick={() => showRejectBonCommandeConfirm(bonCommande)}
                        >
                            Rejeter
                        </Button>)}
                    </>) : bonCommande?.statutCommande === 'APPROUVE' ? (
                        <>
                            <Button type="primary"
                                style={{
                                    backgroundColor: "#1a347d",
                                    borderColor: "#4c757d"
                                }}
                                onClick={() => navigate(`/caisse/attestation/${bonCommande.codeId}`)}>
                                Enregistrer le reglement
                            </Button>
                            <Button type="primary"
                                style={{
                                    backgroundColor: "darkorange",
                                    borderColor: "orange"
                                }}
                                onClick={() => setReceiptModalOpen(true)}>
                                Imprimer la facture
                            </Button>
                            <Modal open={receiptModalOpen} onCancel={() => setReceiptModalOpen(false)} footer={null}
                                width={850}>
                                <InvoiceCard nomCompagnie={bonCommande?.compagnie?.raisonSociale}
                                    actions={bonCommande?.actionsSurCommande}
                                    reglement={bonCommande?.reglement} taxe={taxe?.valeur}
                                    items={bonCommande?.produitAttestationCommandes?.filter(p => p?.produitAttestation?.moyenReglement === 'AVANT_LIVRAISON')} />
                            </Modal>
                        </>

                    ) : (<Alert message={getMessage()} showIcon />)}

                </div>) : (<>
                    <div
                        style={{
                            padding: "16px", background: "#f9f9f9", display: "flex", justifyContent: "center", gap: "16px",
                        }}
                    >
                        {bonCommande?.statutCommande !== "APPROUVE" && bonCommande?.statutCommande !== "DELIVRE" && bonCommande?.statutCommande !== "REGLE" ? (<>

                            <Tooltip
                                title={`${getActionVerb(bonCommande?.statutCommande)?.charAt(0).toUpperCase() + getActionVerb(bonCommande?.statutCommande)?.slice(1).toLowerCase()}  la commande`}
                            >
                                <Button
                                    type="primary"
                                    style={{ backgroundColor: "#28a745", borderColor: "#28a745" }}
                                    icon={getAntdIcon(bonCommande?.statutCommande)}
                                    onClick={() => {
                                        setValidationModalOpen(true)
                                        // showValidationAttestationConfirm(bonCommande?.codeId, bonCommande?.statutCommande,);
                                    }}
                                >
                                    {`${getActionVerb(bonCommande?.statutCommande)?.charAt(0).toUpperCase() + getActionVerb(bonCommande?.statutCommande)?.slice(1).toLowerCase()}  la commande`}
                                </Button>
                            </Tooltip>

                            <Tooltip title={"Rejeter la commande"}>
                                <Button
                                    type="button"
                                    style={{
                                        backgroundColor: "#dc3545", borderColor: "#dc3545", color: "#fff",
                                    }}
                                    onClick={() => showRejectBonCommandeConfirm(bonCommande)}
                                    icon={<i className="bx bx-message-alt-x"></i>}
                                >
                                    Rejeter la commande
                                </Button>
                            </Tooltip>

                        </>) : bonCommande?.statutCommande === 'APPROUVE' ? (
                            <Alert type={"info"} message={'Cette commande est en attente de reglement'} showIcon />) : (
                            <Alert type={"info"} message={'Cette commande est en attente de livraison'} showIcon />)}
                    </div>
                </>)}
            <Tabs defaultActiveKey="details"
                centered
                tabBarGutter={200}
                tabBarStyle={{
                    marginTop: '10px'
                }}
            /*  tabBarStyle={{
                  backgroundColor: "#f0f2f5", borderRadius: "8px", fontSize: '26px', fontWeight: 500

              }}*/
            >
                {/* Details Tab */}
                <Tabs.TabPane tab="DETAILS DE LA COMMANDE" key="details" style={{ padding: "24px" }}>
                    {/* Order Lines */}
                    <Card title="Détails des Produits Attestation" style={{ marginBottom: "24px" }}>
                        <Table
                            dataSource={bonCommande?.produitAttestationCommandes?.map(unit => ({
                                ...unit, key: unit.codeId,
                            }))}
                            columns={productColumns}
                            pagination={false}
                        />
                    </Card>

                    {/* Company Information */}
                    {isConnectedUserFromPOOL() && (<Card
                        title={<Title level={4} style={{ margin: 0 }}>Informations de la Compagnie</Title>}
                        style={{ borderRadius: 10, boxShadow: "0 4px 10px rgba(0,0,0,0.1)", marginBottom: "24px" }}
                    >
                        {bonCommande?.compagnie ? (<Row gutter={32}>
                            {/* Left Section - Company Details */}
                            <Col xs={24} md={8}>
                                <div style={{
                                    width: "100%", display: "flex", flexDirection: "column", alignItems: "center"
                                }}>
                                    {logoImagePreviewUrl && (<Image
                                        src={logoImagePreviewUrl}
                                        alt="Company Logo"
                                        width={200}
                                        height={200}
                                        style={{ objectFit: "contain", marginBottom: "12px" }}
                                        preview={false}
                                    />)}
                                    <div style={{ textAlign: "center" }}>
                                        <Text strong>{bonCommande?.compagnie?.raisonSociale}</Text>
                                        <Divider style={{ margin: "10px 0" }} />
                                        <Text>{bonCommande?.compagnie?.email}</Text>
                                    </div>
                                </div>
                            </Col>
                            {/* Divider */}
                            <Col xs={24} md={1}>
                                <Divider type="vertical" style={{ height: "100%" }} />
                            </Col>
                            {/* Right Section - Trustworthiness Stats */}
                            <Col xs={24} md={15}>
                                <TrustworthinessStats commandes={allOrderForCompany} />
                            </Col>
                        </Row>) : (<Text type="secondary">Aucune information sur la compagnie.</Text>)}
                    </Card>)}

                    {/* Order Timeline */}
                    <OrderTimeline
                        actionsSurCommandes={returnActionDataSource()?.map(action => ({
                            ...action, key: action.codeId,
                        }))}
                        title="Historique"
                        open={timelineOpen}
                        cancel={() => setTimelineOpen(false)}
                    />
                    <Modal
                        title="Modifier Quantité"
                        visible={isEditing}
                        onOk={handleSave}
                        onCancel={handleCancel}
                    >
                        <div style={{ marginBottom: "16px" }}>
                            <p>
                                <strong>Code:</strong> {editData?.codeId}
                            </p>
                            <p>
                                <strong>Catégorie:</strong>{" "}
                                {editData && `${editData.produitAttestation.categorie.nom} (${editData.produitAttestation.categorie.codeCategorie})`}
                            </p>
                            <p>
                                <strong>Quantité actuelle:</strong> {editData?.quantite}
                            </p>
                        </div>
                        <InputNumber
                            min={1}
                            defaultValue={editData?.quantite}
                            onChange={(value) => setEditData({ ...editData, quantite: value })}
                            style={{ width: "100%" }}
                        />
                        <div style={{ marginBottom: "20px", marginTop: "16px" }}>
                            <label
                                style={{
                                    fontSize: "16px",
                                    fontWeight: "600",
                                    color: "#333",
                                    marginBottom: "8px",
                                    display: "block"
                                }}
                            >
                                Entrer le motif de modification
                            </label>
                            <TextArea
                                rows={3}
                                value={commentaire}
                                onChange={(e) => setCommentaire(e.target.value)}
                                placeholder="Ajoutez un commentaire"
                                style={{
                                    borderRadius: "8px",
                                    padding: "10px",
                                    border: "1px solid #ccc",
                                    width: "100%",
                                    fontSize: "14px",
                                    boxSizing: "border-box"
                                }}
                            />
                        </div>
                    </Modal>
                </Tabs.TabPane>

                {/* Actions Tab */}
                <Tabs.TabPane tab="ACTIONS SUR LA COMMANDE" key="actions">
                    <Card title="Actions sur la Commande" style={{ marginBottom: "24px" }}>
                        <Table
                            dataSource={returnActionDataSource()?.map(action => ({
                                ...action, key: action.codeId,
                            }))}
                            columns={actionsColumns}
                            pagination={false}
                        />
                        <Button onClick={() => setTimelineOpen(true)} style={{ marginTop: 16 }}>
                            Voir Timeline
                        </Button>
                    </Card>

                    {/* Edit Modal for Order Line Quantity */}

                </Tabs.TabPane>

                {/* Reçu de Paiement Tab */}
                <Tabs.TabPane tab="RECU DE PAIEMENT" key="recu">
                    {bonCommande?.statutCommande === 'REGLE' || bonCommande?.statutCommande === 'DELIVRE' || bonCommande?.statutCommande === 'RECEPTIONNE' ? (<>
                        <ReceiptCard
                            items={bonCommande?.produitAttestationCommandes}
                            reglement={bonCommande?.reglement} taxe={taxe?.valeur}
                            nomCompagnie={bonCommande?.compagnie?.raisonSociale}
                        />

                    </>) : (<Alert message={`Aucun reglement trouvé pour cette commande`} type={'info'} style={{
                        fontSize: '14px',
                        fontWeight: 500,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }} />)}

                </Tabs.TabPane>
            </Tabs>
        </Card>


        {/* Affectation Section (placed outside tabs if it applies globally) */}
        <AffecterLotAttestation
            compagnie={bonCommande?.compagnie}
            categorie={livraisonData?.produitAttestation?.categorie}
            affectationModalOpen={openAffectationModal}
            typeAttestation={livraisonData?.produitAttestation?.typeAttestation}
            nombre={livraisonData?.quantite}
            handleAffectationModalClose={() => setOpenAffectationModal(false)}
            onSubmit={onSubmit}
        >
            <div style={{ marginBottom: "1rem", marginTop: "5px" }}>
                <label htmlFor="commentaire">Faites un commentaire :</label>
                <textarea
                    id="commentaire"
                    style={{
                        width: "100%",
                        marginTop: "0.5rem",
                        padding: "0.5rem",
                        borderRadius: "4px",
                        border: "1px solid #d9d9d9"
                    }}
                    placeholder="Votre commentaire ici..."
                    onChange={(e) => {
                        com = e.target.value;
                    }}
                />
            </div>
        </AffecterLotAttestation>
        <ValidationAttestattionConfirm statutCommande={bonCommande?.statutCommande}
            onOk={() => validation(bonCommande?.codeId, updateCommentaire)}
            onCancel={() => setValidationModalOpen(false)} loading={loading}
            actionVerb={getActionVerb(bonCommande?.statutCommande)}
            lotA={bonCommande?.codeId} visible={validationModalOpen} />
    </SinglePageLayout>);
};

export default DetailsCompagnie;
